/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V6|V7 API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV6OtpGenerateParams,
  GoogleOtpResponse,
  PatchV6OtpAddParams,
  PatchV6OtpDeleteByUserId200,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary addOtp
 */
export const patchV6OtpAdd = (
  params: MaybeRef<PatchV6OtpAddParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<string>(
    { url: `/api/v6/otp/add`, method: 'PATCH', params: unref(params) },
    options,
  );
};

export const getPatchV6OtpAddMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV6OtpAdd>>,
    TError,
    { params: PatchV6OtpAddParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV6OtpAdd>>,
  TError,
  { params: PatchV6OtpAddParams },
  TContext
> => {
  const mutationKey = ['patchV6OtpAdd'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV6OtpAdd>>,
    { params: PatchV6OtpAddParams }
  > = (props) => {
    const { params } = props ?? {};

    return patchV6OtpAdd(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV6OtpAddMutationResult = NonNullable<Awaited<ReturnType<typeof patchV6OtpAdd>>>;

export type PatchV6OtpAddMutationError = ErrorType<unknown>;

/**
 * @summary addOtp
 */
export const usePatchV6OtpAdd = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV6OtpAdd>>,
      TError,
      { params: PatchV6OtpAddParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV6OtpAdd>>,
  TError,
  { params: PatchV6OtpAddParams },
  TContext
> => {
  const mutationOptions = getPatchV6OtpAddMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary deleteOtp
 */
export const patchV6OtpDeleteByUserId = (
  userId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  userId = unref(userId);

  return customAxiosInstance<PatchV6OtpDeleteByUserId200>(
    { url: `/api/v6/otp/delete/${userId}`, method: 'PATCH' },
    options,
  );
};

export const getPatchV6OtpDeleteByUserIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV6OtpDeleteByUserId>>,
    TError,
    { userId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV6OtpDeleteByUserId>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationKey = ['patchV6OtpDeleteByUserId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV6OtpDeleteByUserId>>,
    { userId: number }
  > = (props) => {
    const { userId } = props ?? {};

    return patchV6OtpDeleteByUserId(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV6OtpDeleteByUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV6OtpDeleteByUserId>>
>;

export type PatchV6OtpDeleteByUserIdMutationError = ErrorType<unknown>;

/**
 * @summary deleteOtp
 */
export const usePatchV6OtpDeleteByUserId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV6OtpDeleteByUserId>>,
      TError,
      { userId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV6OtpDeleteByUserId>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationOptions = getPatchV6OtpDeleteByUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary generateOtp
 */
export const getV6OtpGenerate = (
  params: MaybeRef<GetV6OtpGenerateParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<GoogleOtpResponse>(
    { url: `/api/v6/otp/generate`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV6OtpGenerateQueryKey = (params?: MaybeRef<GetV6OtpGenerateParams>) => {
  return ['api', 'v6', 'otp', 'generate', ...(params ? [params] : [])] as const;
};

export const getGetV6OtpGenerateQueryOptions = <
  TData = Awaited<ReturnType<typeof getV6OtpGenerate>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV6OtpGenerateParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV6OtpGenerate>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV6OtpGenerateQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV6OtpGenerate>>> = ({ signal }) =>
    getV6OtpGenerate(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV6OtpGenerate>>,
    TError,
    TData
  >;
};

export type GetV6OtpGenerateQueryResult = NonNullable<Awaited<ReturnType<typeof getV6OtpGenerate>>>;
export type GetV6OtpGenerateQueryError = ErrorType<unknown>;

/**
 * @summary generateOtp
 */

export function useGetV6OtpGenerate<
  TData = Awaited<ReturnType<typeof getV6OtpGenerate>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV6OtpGenerateParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV6OtpGenerate>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV6OtpGenerateQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
